import { Spin } from 'antd';
import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import PageSizeButton from '../../../../components/PageSizeButton/PageSizeButton';
import pageSizes from '../../../../components/PageSizeButton/pageSizes';
import Pagination from '../../../../components/Pagination/Pagination';
import getName from '../../../../helpers/getName';
import usePagination from '../../../../hooks/usePagination';
import useParam from '../../../../hooks/useParam';
import LayeredTable from '../../components/tables/layeredTable/LayeredTable/LayeredTable';
import useFacilities from '../../queries/useFacilities';
import FilterCell from '../FilterCell/FilterCell';
import queries from '../../queries/queries';
import useSetRefreshFn from '../../../../hooks/useSetRefreshFn';
import styles from './Facilities.module.scss';

const properties = [
  { name: 'number', flex: 0.3, highlight: true, header: '№' },
  { name: 'name', flex: 1, highlight: true, header: 'Название объекта' },
  { name: 'house.fullAddress', flex: 1, header: 'Адрес объекта' },
  {
    name: 'manager',
    header: <FilterCell text="Управляющий" paramKey="managerIds" />,
    flex: 1,
    customCellContent: (facility) => getName(facility.manager),
  },
  {
    name: 'broker',
    header: <FilterCell text="Брокер" paramKey="brokerIds" />,
    flex: 1,
    customCellContent: (facility) => getName(facility.broker),
  },
  { name: 'totalArea', flex: 0.7, header: 'Общая площадь' },
  { name: 'areaForRent', flex: 0.7, header: 'Площадь под сдачу' },
  { name: 'officesAmount', flex: 0.7, header: 'Кол-во помещений' },
  { name: 'rentedOfficesAmount', flex: 0.7, header: 'Сдано' },
];
const parseArrayParam = (arr) => arr.map((value) => Number(value));
const Facilities = () => {
  const [pageSize, setPageSize] = useState(pageSizes[0]);
  const history = useHistory();
  const queryClient = useQueryClient();
  const managerIds = useParam('managerIds', [], parseArrayParam);
  const brokerIds = useParam('brokerIds', [], parseArrayParam);
  const searchString = useParam('search', '');
  const { data: facilities, isFetching } = useFacilities(
    searchString,
    managerIds,
    brokerIds
  );
  const [
    currentPageNumber,
    setCurrentPageNumber,
    maxPage,
    shownFacilities,
    firstIndexOnPage,
  ] = usePagination(facilities, pageSize);
  const clickFacilityName = useCallback((facility) => {
    history.push(`/Offices/facilities/${facility.id}/rooms`);
  }, [history]);

  useSetRefreshFn(() => {
    queryClient.invalidateQueries([
      queries.facilities,
      searchString,
      managerIds,
      brokerIds,
    ]);
  }, [searchString, managerIds, brokerIds]);

  return (
    <Spin spinning={isFetching}>
      <LayeredTable
        data={shownFacilities}
        rowDataPropertiesArray={properties}
        rowOnClick={clickFacilityName}
      />
      <Pagination
        maxPage={maxPage}
        setPageNumber={setCurrentPageNumber}
        currentPageNumber={currentPageNumber}
        firstIndexOnPage={firstIndexOnPage}
        lastIndexOnPage={firstIndexOnPage + shownFacilities?.length}
        totalAmount={facilities.length}
      />
      <div className={styles.buttonRow}>
        <PageSizeButton pageSize={pageSize} setPageSize={setPageSize} />
      </div>
    </Spin>
  );
};

export default Facilities;
